import React, { useEffect } from 'react'
import './styles/app.sass'
import './styles/custom.scss'
import './global.module.css'
import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom'
import { PORTALS, IS_IOS } from 'common/constants'
import { useSelector, useDispatch } from 'react-redux'
import cryptoRoutes from './routes/cryptoRoutes'
import AuthMiddleware from 'routes/middleware/Authmiddleware'
import Page from 'components/Page'
import ErrorBoundary from 'components/ErrorBoundary'
import 'react-toastify/dist/ReactToastify.css'
import { checkPushNotificationSubscription } from "serviceWorkerRegistration"
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchReferenceCurrency, receivedNotification, toggleCurrentModal, updatePushNotificationOption } from 'store/actions'
import { initSockets } from 'socket/htx'
import SocketProvider from 'context';
import { EnableTwoFactorAuthModal } from 'components/TwoFactorAuth/EnableTwoFactorAuthModal'

const lang = localStorage.getItem('I18N_LANGUAGE')

const channel = new BroadcastChannel('notification--exinitic--messages')

const routeSelector = (portal) => {
  let defaultRoutes
  switch (portal) {
    case PORTALS.CRYPTO:
      return cryptoRoutes
    default:
      return cryptoRoutes
  }
}



function App() {
  const dispatch = useDispatch()
  const location = useLocation()
  const notification = (!IS_IOS && Notification?.permission) || null
  const { portal } = useSelector((state) => state.Layout)
  const profile = useSelector(state => state.Profile.clientData)
  const profileSuccess = useSelector(state => state.Profile.success)
  let routes = routeSelector(portal)
  const [searchParams] = useSearchParams();

  channel.onmessage = (event) => {
    const formattedData = formatReceivedNotification(event.data)
    if (formattedData._id) {
      dispatch(receivedNotification(formattedData))
    }
  }


  const checkAndUpdateNotification = async () => {
    const checkCurrentNotification = await checkPushNotificationSubscription()
    dispatch(updatePushNotificationOption(checkCurrentNotification))
  }

  useEffect(() => {
    checkAndUpdateNotification()
  }, [notification])

  useEffect(() => {
    window.scroll(0, 0)
  }, [location])

  useEffect(() => {
    console.log(profile)
    console.log(profile.settings && !profile.settings.twoFactorAuthEnabled)
    if (profileSuccess && profile.settings && !profile.settings.twoFactorAuthEnabled)
      dispatch(toggleCurrentModal("unclosableEnableTwoFactorAuthModal"))
  }, [profile])

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      localStorage.setItem("authUser", JSON.stringify({
         token 
      }))
      window.location.reload()
    }
  }, [searchParams])

  useEffect(() => {
    dispatch(fetchReferenceCurrency())
  }, [])

  return (
    <SocketProvider>
      <ErrorBoundary>
        <EnableTwoFactorAuthModal currentModal="unclosableEnableTwoFactorAuthModal" isClosable={false} />
        <Routes>
          {routes?.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthMiddleware
                  isAuthProtected={route.isAuth}
                  isNotAuthProtected={route.isNotAuthProtected}
                  component={route.component}
                  layout={Page}
                  headerHide={route.headerHide}
                  footerHide={route.footerHide}
                  headerWide={route.headerWide}
                  stickyHeader={route.stickyHeader}
                />
              }
            />
          ))}
        </Routes>
      </ErrorBoundary>
    </SocketProvider>
  )
}

export default App
